module.exports = __webpack_public_path__ + "img/manda_032.19908304.png";